<template>
  <multiselect
    v-model="selected"
    :options="options"
    track-by="value"
    label="name"
    :placeholder="placeholder"
    :multiple="false"
    searchable
  />
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },

  props: {
    options: { type: Array, required: true },
    placeholder: { type: String, default: 'Show 10' },
    value: { type: [Number, String], default: 10 },
  },

  computed: {
    selected: {
      get() {
        return (
          this.options.find((o) => o.value === this.value) || {
            value: this.value,
            name: `Show ${this.value}`,
          }
        );
      },
      set(value) {
        this.$emit('input', value?.value || 10);
      },
    },
  },
};
</script>

<style>
.multiselect {
  border: none !important;
}
.multiselect__tags {
  border: none !important;
  background: #f5f5f5;
}
.multiselect__placeholder {
  color: black;
}
.multiselect__input {
  background: none;
}
.multiselect__select:before {
  border-color: #000 transparent transparent;
}

.multiselect__single {
  background: transparent;
}
</style>
